import { ColDef } from "ag-grid-community";
import { DetailRow, RecurringRow } from "./recurring-detector.service";
import { formatAbsAmount } from "./transaction.utils";
import {
  RdActionRendererComponent,
  RdAvgAmountRendererComponent,
  RdChangeRendererComponent,
  RdDescriptionRendererComponent,
  RdNextDueRendererComponent,
  RdStatusRendererComponent,
} from "./recurring-detector-renderers";

export function getMainColumns(
  isRecurring: boolean,
  onDetail: (row: RecurringRow) => void,
  onMove: (row: RecurringRow) => void,
): ColDef<RecurringRow>[] {
  const cols: ColDef<RecurringRow>[] = [
    {
      field: "description",
      headerName: "Description",
      flex: 1,
      minWidth: 120,
      cellClass: "rd-cell-description",
      cellRenderer: RdDescriptionRendererComponent,
      cellRendererParams: { onDetail },
    },
    {
      field: "frequency",
      headerName: "Frequency",
      flex: 1,
      minWidth: 130,
      cellClass: "rd-cell-pad-center",
    },
    {
      field: "count",
      headerName: "Payments",
      flex: 1,
      minWidth: 100,
      cellClass: "rd-cell-pad-center",
    },
    {
      headerName: "Avg Amount",
      field: "avgAmount",
      flex: 1,
      minWidth: 150,
      cellClass: "rd-cell-pad-right",
      cellRenderer: RdAvgAmountRendererComponent,
    },
  ];

  if (isRecurring) {
    cols.push({
      headerName: "Next Due",
      field: "nextExpected",
      flex: 1,
      minWidth: 130,
      cellClass: "rd-cell-pad",
      // nextExpected is UTC midnight — compare in UTC so UTC+ users don't see today as overdue.
      cellRenderer: RdNextDueRendererComponent,
    });
  }

  cols.push({
    field: "status",
    headerName: "Status",
    flex: 1,
    minWidth: 100,
    cellClass: "rd-cell-pad-center",
    cellRenderer: RdStatusRendererComponent,
  });

  cols.push({
    colId: "action",
    headerName: "Action",
    flex: 1,
    minWidth: 180,
    cellClass: "rd-cell-action",
    cellRenderer: RdActionRendererComponent,
    cellRendererParams: { onMove, isRecurring },
  });

  return cols;
}

export function getDetailColumns(): ColDef<DetailRow>[] {
  return [
    {
      field: "date",
      headerName: "Date",
      flex: 1,
      cellClass: "rd-cell-pad",
    },
    {
      field: "amount",
      headerName: "Amount",
      flex: 1,
      type: "numericColumn",
      cellClass: "rd-cell-pad-right",
      valueFormatter: (p) => {
        if (p.value == null) {
          return "—";
        }
        const formatted = formatAbsAmount(p.value);
        const currency = p.data?.currency;
        return currency ? `${currency} ${formatted}` : formatted;
      },
    },
    {
      field: "change",
      headerName: "Change",
      width: 130,
      type: "numericColumn",
      cellClass: "rd-cell-pad-right",
      cellRenderer: RdChangeRendererComponent,
    },
  ];
}
